<input
    #searchInput
    class="logs-filter-input"
    [placeholder]="placeholder"
    [ngModel]="isActive ? filter : ''"
    (ngModelChange)="handleFilterChange($event)"
    logsEditableFilterInputEvents
    (onFocus)="handleFocus()"
    (onSubmit)="submit()"
    (onBackspace)="onBackspace.emit()"
/>
